import { FieldReadFunction } from '@apollo/client'

import { PermissionGateName, ResolvedPermissionResolution } from '@acre/graphql'

const read: FieldReadFunction<PermissionGateName[]> = (_, { readField }) => {
  const permissions = readField<ResolvedPermissionResolution[]>({
    fieldName: 'permissions',
  })

  const cache = new Set<string>()

  return permissions?.reduce((acc, permission) => {
    const gate = readField<PermissionGateName>({ from: permission, fieldName: 'gate' })

    if (!gate || cache.has(gate)) {
      return acc
    }

    const hasPermission = readField<boolean>({ from: permission, fieldName: 'has_permission' })

    if (hasPermission) {
      cache.add(gate)
      acc.push(gate)
    }

    return acc
  }, [] as PermissionGateName[])
}

export default {
  read,
}
